import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {EntityIdDetails, EntityType} from '../../../../shared/models/entity-id-details.model';
import {Right, TransactionRule, TxRuleData} from '../../right.model';
import {FormBuilder, FormGroup, Validators, AbstractControl} from '@angular/forms';
import {BankAccount} from '../../../../shared/models/bank-account.model';
import {BankInstitution} from '../../../../shared/models/bank-institution.model';
import {ApplicationValue} from '../../../../services/warmup/application-type.model';
import {GenericSearchDetails} from '../../../../shared/models/generic-search-details.model';
import {ConstantsService} from '../../../../services/constants-service';
import {MessageService} from '../../../../services/messages.service';
import {MdDialogRef, MdDialog, MdDialogConfig} from '@angular/material';
import {EntityTransactionProfileService} from '../../entity-transaction-profile.service';
import {TrackingService} from '../../../../shared/services/tracking/google-analytics-events.service';
import {EntityRelationsService} from '../../../relations/entity-relations.service';
import {SnackBarService} from '../../../../services/snackbar.service';
import {ApplicationTypeConstants, WarmUpService} from '../../../../services/warmup/warmup.service';
import {EntityRelation} from '../../../../shared/models/entity-relation.model';
import {OverlayPanel} from 'primeng/primeng';
import {Obligation} from '../../obligation.model';
import {Observable} from 'rxjs/Observable';
import {TransactionDescriptionBuilder} from '../transaction-rule-descriptionn-builder';
import {Agreement} from '../../agreement.model';
import {SaveAgreementComponent} from '../../agreements/saveagreement/save-agreement.component';
import {BankAccountComponent} from '../../../finance/bankaccount/bank-account.component';
import {FinanceService} from '../../../../finance/finance.service';

@Component({
  selector: 'app-add-transaction-rule',
  templateUrl: './add-transaction-rule.component.html',
  styleUrls: ['./add-transaction-rule.component.css']
})
export class AddTransactionRuleComponent implements OnInit {

  @ViewChild('container') container: ElementRef;
  @ViewChild('op') overlayPanel: OverlayPanel;
  entityIdDetails: EntityIdDetails;
  action: string;
  selectedTxRule: TxRuleData;
  ruleForm: FormGroup;
  isLoading = false;
  selectedIndex = 0;
  agreementId: number;
  options = {};
  showClientPage = false;
  transactionRules: TransactionRule[];
  transactionRuleId: number;
  actionType: string;
  bankAccounts: BankAccount[]; // Client's bank accounts
  counterpartyBankAccounts: BankAccount[]; // Counterparty's bank accounts
  selectedBankAccount: BankAccount | null = null; // Currently selected bank account
  bankInstitutions: BankInstitution[] = []; // Bank institutions for editing
  countryTypes: ApplicationValue[];
  cashFlows: ApplicationValue[];
  transactionFrequencyPeriods: ApplicationValue[];
  roles: ApplicationValue[];
  counterParties: any[];
  selectedTranactionRule: TransactionRule;
  selectedEntity: GenericSearchDetails;
  searchURI = ConstantsService.HEADER_SEARCH;
  searchPlaceholder = MessageService.HEADER_SEARCH_PLACEHOLDER;
  amountRangeCheckbox: boolean;
  maxAmountCheckbox: boolean;
  frequencyCheckbox: boolean;
  originCountryCheckbox: boolean;
  counterPartyCheckbox: boolean;
  lastTrxId: number | null;
  
  // Agreement/Transactional Relationship properties
  agreements: Agreement[] = [];
  filteredAgreements: Agreement[] = [];
  selectedAgreement: Agreement = null;
  agreementSearchKeyword: string = '';
  showAgreementSelection: boolean = false;
  isAgreementInputFocused: boolean = false;
  isSelectingAgreement: boolean = false;

  formErrors = {
    'name': '',
    'transactionalRelationship': '',
    'ruleCriteria': '',
    'accountNo': '',
  };

  validationMessages = {
    'name': {
      'required': 'Required field value.',
    },
    'accountNo': {
      'required': 'Client bank account is required.',
    },
    'ruleCriteria': {
      'required': 'Select a counterparty, enter a counterparty account number, or provide description with From and To amounts.',
    }
  };

  constructor(
    public dialogRef: MdDialogRef<any>,
    private fb: FormBuilder,
    private entityTransactionProfileService: EntityTransactionProfileService,
    private trackingService: TrackingService,
    private entityRelationsService: EntityRelationsService,
    private snackBarService: SnackBarService,
    private warmUpService: WarmUpService,
    private cdRef: ChangeDetectorRef,
    private dialog: MdDialog,
    private financeService: FinanceService
  ) { }

  ngOnInit() {
    this.transactionRuleId = this.selectedTxRule && this.selectedTxRule.id;
    // Initialize counterparty bank accounts array
    this.counterpartyBankAccounts = [];
    
    // Pre-load bank institutions immediately so they're available for editing
    this.loadBankInstitutions();
    
    this.buildForm();
    if (this.action === 'Edit') {
      // Check if transactionRule exists before trying to edit
      if (this.selectedTxRule && this.selectedTxRule.transactionRule) {
        this.editTransactionRule(this.selectedTxRule.transactionRule);
      } else {
        console.error('Cannot edit transaction rule: transactionRule is null or missing', this.selectedTxRule);
        // Show error message to user
        this.snackBarService.showSimpleMsj('Error: Transaction rule data is missing. The rule may have been deleted or corrupted.');
      }
    }
    // Load agreements if agreementId is 0 (new profile)
    if (this.agreementId === 0 && this.entityIdDetails && this.entityIdDetails.entityId) {
      this.loadAgreements().subscribe(
        agreements => {
          // Agreements loaded successfully
        },
        error => {
          console.error('Error loading agreements on init:', error);
        }
      );
      this.showAgreementSelection = true;
    } else if (this.agreementId && this.agreementId > 0) {
      // If agreementId is set, load that specific agreement
      this.loadAgreements().subscribe(
        agreements => {
          // Agreements loaded successfully
        },
        error => {
          console.error('Error loading agreements on init:', error);
        }
      );
    }
  }

  buildForm() {
    this.loadData();
    this.ruleForm = this.fb.group({
      name: ['', Validators.required],
      counterParty: [''],
      counterPartyId: [''],
      clientName: [''],
      profileName: [''],
      txnDescription: [''],
      accountNo: ['', Validators.required],
      cashFlow: [''],
      amountFrom: [''],
      searchValue: [''],
      amountTo: [''],
      transactionalRelationship: [''],
      transactionalRelationshipId: [this.agreementId || 0],
      maxAmount: [''],
      maxAmountPeriod: [''],
      frequency: [''],
      frequencyPeriod: [''],
      originCountry: [''],
      counterPartyName: [''],
      role: [''],
      counterPartyAccountNumber: [''],
    }, { validator: this.ruleCriteriaValidator });
    this.options = {
      amountRange: true,
      maxAmount: true,
      frequency: true,
      originCountry: true,
      counterParty: true
    };
    this.initCheckboxChecked();
    this.ruleForm.get('name').valueChanges.subscribe(val => {
      this.ruleForm.get('profileName').setValue(val);
    });
    // Auto-open overlay when counterPartyName is cleared
    this.ruleForm.get('counterPartyName').valueChanges.subscribe(val => {
      if (!val || val === '') {
        // Clear counterPartyId when name is cleared
        this.ruleForm.patchValue({ counterPartyId: '' }, { emitEvent: false });
        // Auto-open overlay after a short delay to ensure the field is updated
        setTimeout(() => {
          if (this.overlayPanel && !this.overlayPanel.visible) {
            const counterPartyInput = document.getElementById('counterParty');
            if (counterPartyInput) {
              this.showRelation({ target: counterPartyInput }, this.overlayPanel);
            }
          }
        }, 100);
      }
      // If name is set programmatically (prefill/restore), resolve entityId if missing
      if (val && val !== '') {
        this.tryResolveCounterPartyIdFromName();
      }
    });
    // Track selected bank account
    this.ruleForm.get('counterPartyAccountNumber').valueChanges.subscribe(accountNumber => {
      this.updateSelectedBankAccount(accountNumber);
    });
    this.ruleForm.valueChanges.subscribe(data => {
      this.onValueChanged(data);
    });
    this.onValueChanged();
    this.updateTxDataForm();
  }

  ruleCriteriaValidator(control: AbstractControl): { [key: string]: any } | null {
    const formGroup = control as FormGroup;
    const counterPartyIdControl = formGroup.get('counterPartyId');
    const counterPartyAccountNumberControl = formGroup.get('counterPartyAccountNumber');
    const txnDescriptionControl = formGroup.get('txnDescription');
    const amountFromControl = formGroup.get('amountFrom');
    const amountToControl = formGroup.get('amountTo');

    const counterPartyId = counterPartyIdControl ? counterPartyIdControl.value : null;
    const counterPartyAccountNumber = counterPartyAccountNumberControl
      ? counterPartyAccountNumberControl.value
      : null;
    const txnDescription = txnDescriptionControl ? txnDescriptionControl.value : null;
    const amountFrom = amountFromControl ? amountFromControl.value : null;
    const amountTo = amountToControl ? amountToControl.value : null;

    // If counter party is provided, validation passes
    if (counterPartyId && counterPartyId !== '' && counterPartyId !== null && counterPartyId !== 0) {
      return null;
    }

    // Counterparty account number alone is a valid rule criterion
    if (counterPartyAccountNumber && typeof counterPartyAccountNumber === 'string'
        && counterPartyAccountNumber.trim() !== '') {
      return null;
    }

    // If no counter party, then description AND both amounts are required
    const hasDescription = txnDescription && typeof txnDescription === 'string' && txnDescription.trim() !== '';
    const hasAmountFrom = amountFrom && amountFrom !== '' && amountFrom != null;
    const hasAmountTo = amountTo && amountTo !== '' && amountTo != null;

    if (hasDescription && hasAmountFrom && hasAmountTo) {
      return null;
    }

    // Validation failed
    return { ruleCriteria: true };
  }

  updateTxDataForm(): void {
    if (this.selectedTxRule) {
      this.ruleForm.patchValue({
        name: this.selectedTxRule.title,
        counterPartyName: this.selectedTxRule.counterPartyName,
        counterPartyId: this.selectedTxRule.counterPartyId
      });
    }
  }

  updateTransactionFormWithTransactionRule(): void {
    if (this.selectedTranactionRule) {
      // DEBUG: Log the account data to understand the issue
      console.log('=== TRANSACTION RULE ACCOUNT DEBUG ===');
      console.log('Selected Transaction Rule:', this.selectedTranactionRule);
      console.log('AccountNo from rule:', this.selectedTranactionRule.accountNo);
      console.log('AccountNo type:', typeof this.selectedTranactionRule.accountNo);
      console.log('AccountNo length:', this.selectedTranactionRule.accountNo ? this.selectedTranactionRule.accountNo.length : 'null/undefined');
      console.log('Available Bank Accounts:', this.bankAccounts);
      console.log('Bank Accounts count:', this.bankAccounts ? this.bankAccounts.length : 'null/undefined');
      if (this.bankAccounts && this.bankAccounts.length > 0) {
        console.log('Bank Account Numbers:', this.bankAccounts.map(ba => ({
          accountNumber: ba.accountNumber,
          accountNumberType: typeof ba.accountNumber,
          accountNumberLength: ba.accountNumber ? ba.accountNumber.length : 'null/undefined',
          accountId: ba.accountId,
          accountName: ba.accountName
        })));
        // Check if accountNo matches any bank account
        const matchingAccount = this.bankAccounts.find(ba => ba.accountNumber === this.selectedTranactionRule.accountNo);
        console.log('Matching Account Found:', matchingAccount ? 'YES' : 'NO');
        if (matchingAccount) {
          console.log('Matching Account Details:', matchingAccount);
        } else {
          console.log('NO MATCH FOUND - AccountNo does not match any bank account number');
          // Try to find by trimming whitespace
          const trimmedAccountNo = this.selectedTranactionRule.accountNo ? this.selectedTranactionRule.accountNo.trim() : '';
          const trimmedMatch = this.bankAccounts.find(ba => ba.accountNumber && ba.accountNumber.trim() === trimmedAccountNo);
          console.log('Trimmed Match Found:', trimmedMatch ? 'YES' : 'NO');
        }
      } else {
        console.log('WARNING: Bank accounts array is empty or not loaded yet!');
      }
      console.log('=====================================');
      
      this.ruleForm.patchValue({
        profileName: this.selectedTranactionRule.name,
        counterPartyName: this.selectedTranactionRule.counterPartyName,
        counterPartyId: this.selectedTranactionRule.counterPartyId,
        accountNo: this.selectedTranactionRule.accountNo,
        counterPartyAccountNumber: this.selectedTranactionRule.counterPartyAccountNumber,
        txnDescription: this.selectedTranactionRule.txnDescription,
        amountFrom: this.selectedTranactionRule.amountFrom,
        amountTo: this.selectedTranactionRule.amountTo,
        maxAmount: this.selectedTranactionRule.maxAmount,
        maxAmountPeriod: this.selectedTranactionRule.maxAmountPeriod,
        frequency: this.selectedTranactionRule.frequency,
        frequencyPeriod: this.selectedTranactionRule.frequencyPeriod,
        originCountry: this.selectedTranactionRule.originCountry,
        cashFlow: this.selectedTranactionRule.cashFlow,
      });
      
      // DEBUG: Log form value after patching
      console.log('Form accountNo value after patchValue:', this.ruleForm.get('accountNo').value);
      console.log('Form accountNo value type:', typeof this.ruleForm.get('accountNo').value);
      
      this.updateTxDataForm();
      if (this.selectedTranactionRule.amountFrom + this.selectedTranactionRule.amountTo) {
        this.options['amountRange'] = true;
        this.amountRangeCheckbox = true;
      }
      if (this.selectedTranactionRule.maxAmount) {
        this.options['maxAmountPeriod'] = true;
        this.maxAmountCheckbox = true;
      }
      if (this.selectedTranactionRule.frequency) {
        this.options['frequency'] = true;
        this.frequencyCheckbox = true;
      }

      if (this.selectedTranactionRule.originCountry) {
        this.options['originCountry'] = true;
        this.originCountryCheckbox = true;
      }
      if (this.selectedTranactionRule.counterPartyId) {
        this.options['counterPartyId'] = true;
        this.counterPartyCheckbox = true;
        // Load counterparty bank accounts when counterparty is set
        this.loadCounterpartyBankAccounts(this.selectedTranactionRule.counterPartyId);
      }
    }
  }
  
  /**
   * Pre-load bank institutions so they're available immediately for editing
   */
  private loadBankInstitutions(): void {
    this.financeService.getBankInstitutionsList().subscribe(
      banks => {
        this.bankInstitutions = banks;
        console.log('Bank institutions pre-loaded:', this.bankInstitutions.length);
      },
      error => {
        console.error('Error pre-loading bank institutions:', error);
        // Don't block - will load on-demand if needed
      }
    );
  }

  /**
   * Load bank accounts for the counterparty entity
   * Uses caching to avoid duplicate queries for the same counterparty
   */
  private counterpartyBankAccountsCache: Map<number, BankAccount[]> = new Map();
  
  clearCounterParty(): void {
    const counterpartyId = this.ruleForm.get('counterPartyId').value;

    this.ruleForm.patchValue({
      counterPartyName: '',
      counterPartyId: ''
    });

    this.counterpartyBankAccounts = [];
    this.selectedBankAccount = null;

    if (counterpartyId) {
      this.counterpartyBankAccountsCache.delete(counterpartyId);
    }
  }

  onCounterpartyAccountSelected(accountNumber: string): void {
    if (accountNumber) {
      this.ruleForm.patchValue({ counterPartyAccountNumber: accountNumber });
      this.updateSelectedBankAccount(accountNumber);
    }
  }

  clearOriginCountry(): void {
    this.ruleForm.patchValue({
      originCountry: ''
    });
  }

  loadCounterpartyBankAccounts(counterpartyEntityId: number): void {
    if (!counterpartyEntityId) {
      this.counterpartyBankAccounts = [];
      return;
    }
    
    // Check cache first
    if (this.counterpartyBankAccountsCache.has(counterpartyEntityId)) {
      this.counterpartyBankAccounts = this.counterpartyBankAccountsCache.get(counterpartyEntityId);
      console.log('Counterparty bank accounts loaded from cache for entity:', counterpartyEntityId);
      this.updateSelectedBankAccount(this.ruleForm.get('counterPartyAccountNumber').value);
      return;
    }
    
    // Load from API and cache the result
    this.entityTransactionProfileService.getBankAccountsForEntity(counterpartyEntityId)
      .subscribe(response => {
        this.counterpartyBankAccounts = response;
        // Cache the result for future use
        this.counterpartyBankAccountsCache.set(counterpartyEntityId, response);
        console.log('=== COUNTERPARTY BANK ACCOUNTS LOADED ===');
        console.log('Counterparty Entity ID:', counterpartyEntityId);
        console.log('Counterparty Bank Accounts:', this.counterpartyBankAccounts);
        console.log('Counterparty Bank Accounts count:', this.counterpartyBankAccounts ? this.counterpartyBankAccounts.length : 'null/undefined');
        if (this.counterpartyBankAccounts && this.counterpartyBankAccounts.length > 0) {
          console.log('Counterparty Bank Account Numbers:', this.counterpartyBankAccounts.map(ba => ba.accountNumber));
          console.log('Counterparty Bank Account Names:', this.counterpartyBankAccounts.map(ba => ba.accountName));
          console.log('First account full object:', JSON.stringify(this.counterpartyBankAccounts[0]));
          // Check if accountName property exists
          this.counterpartyBankAccounts.forEach((ba, index) => {
            console.log(`Account ${index}:`, {
              accountNumber: ba.accountNumber,
              accountName: ba.accountName,
              hasAccountName: 'accountName' in ba,
              accountNameType: typeof ba.accountName,
              accountNameValue: ba.accountName
            });
          });
        }
        console.log('==========================================');
        // Update selected bank account if one is already selected
        const currentAccountNumber = this.ruleForm.get('counterPartyAccountNumber').value;
        if (currentAccountNumber) {
          this.updateSelectedBankAccount(currentAccountNumber);
        }
      });
  }

  /**
   * Update the selected bank account based on account number
   */
  private updateSelectedBankAccount(accountNumber: string): void {
    if (!accountNumber) {
      this.selectedBankAccount = null;
      return;
    }
    this.selectedBankAccount = this.counterpartyBankAccounts.find(ba => ba.accountNumber === accountNumber) || null;
    if (this.selectedBankAccount) {
      console.log('Selected bank account found:', this.selectedBankAccount);
      console.log('Account name:', this.selectedBankAccount.accountName);
      console.log('Account number:', this.selectedBankAccount.accountNumber);
    } else {
      console.log('No bank account found for account number:', accountNumber);
      console.log('Available accounts:', this.counterpartyBankAccounts.map(ba => ({ number: ba.accountNumber, name: ba.accountName })));
    }
  }

  /**
   * Get the selected bank account by account number
   */
  getSelectedBankAccount(): BankAccount | null {
    return this.selectedBankAccount;
  }

  /**
   * Add new bank account for the counterparty
   */
  addBankAccount(): void {
    const counterpartyId = this.ruleForm.get('counterPartyId').value;
    if (!counterpartyId) {
      console.warn('Cannot add bank account: No counterparty selected');
      return;
    }

    const config = new MdDialogConfig();
    config.disableClose = true;

    const dialogRef = this.dialog.open(BankAccountComponent, config);
    dialogRef.componentInstance.action = 'Add';
    
    // Set the account holder to the counterparty entity
    // Use setTimeout to ensure it's set after ngOnInit runs
    setTimeout(() => {
      dialogRef.componentInstance.accountHolderEntityId = counterpartyId;
      
      // Initialize form if not already done
      if (!dialogRef.componentInstance.bankAccountForm) {
        dialogRef.componentInstance.createForm();
      }
      
      // Pre-fill account name with counterparty name if available
      const counterpartyName = this.ruleForm.get('counterPartyName').value;
      if (counterpartyName && dialogRef.componentInstance.bankAccountForm) {
        dialogRef.componentInstance.bankAccountForm.controls['accountName'].setValue(counterpartyName);
      }
      
      // Pass already-loaded bank institutions if available
      if (this.bankInstitutions && this.bankInstitutions.length > 0) {
        dialogRef.componentInstance.bankInstitutions = this.bankInstitutions;
      }
    }, 200);

    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        // Clear cache and reload bank accounts for the counterparty after adding
        this.counterpartyBankAccountsCache.delete(counterpartyId);
        this.loadCounterpartyBankAccounts(counterpartyId);
        
        // If a new account was created, optionally select it
        // (The user can manually select it from the dropdown)
      }
    });
  }

  /**
   * Edit bank account
   */
  editBankAccount(): void {
    const selectedAccount = this.getSelectedBankAccount();
    if (!selectedAccount) {
      return;
    }

    // Open dialog immediately for better UX - don't wait for bank institutions
    // The BankAccountComponent will load them if needed
    this.openEditBankAccountDialog(selectedAccount);
    
    // Load bank institutions in background if not already loaded (for next time)
    if (this.bankInstitutions.length === 0) {
      this.financeService.getBankInstitutionsList().subscribe(
        banks => {
          this.bankInstitutions = banks;
        },
        error => {
          console.error('Error loading bank institutions:', error);
        }
      );
    }
  }

  /**
   * Open the bank account edit dialog
   */
  private openEditBankAccountDialog(account: BankAccount): void {
    const bank = this.bankInstitutions.find(b => b.bankId === account.bankInstitutionId);
    const action = 'Edit';
    const config = new MdDialogConfig();
    config.disableClose = true;

    const dialogRef = this.dialog.open(BankAccountComponent, config);
    dialogRef.componentInstance.selectedBankAccount = account;
    dialogRef.componentInstance.bankInstitution = bank;
    dialogRef.componentInstance.action = action;
    
    // Pass already-loaded bank institutions to avoid duplicate API call
    if (this.bankInstitutions && this.bankInstitutions.length > 0) {
      dialogRef.componentInstance.bankInstitutions = this.bankInstitutions;
    }
    
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        // Reload bank accounts for the counterparty after editing
        // Clear cache to force reload with updated data
        const counterpartyId = this.ruleForm.get('counterPartyId').value;
        if (counterpartyId) {
          this.counterpartyBankAccountsCache.delete(counterpartyId);
          this.loadCounterpartyBankAccounts(counterpartyId);
        }
      }
    });
  }

  initCheckboxChecked() {
    this.amountRangeCheckbox = true;
    this.maxAmountCheckbox = true;
    this.frequencyCheckbox = true;
    this.originCountryCheckbox = true;
    this.counterPartyCheckbox = true;
  }

  loadData() {
    this.loadTransactionRules();
    this.entityTransactionProfileService.getBankAccountsForEntity(
      this.entityIdDetails.entityId).subscribe(response => {
      this.bankAccounts = response;
      // DEBUG: Log when bank accounts are loaded
      console.log('=== BANK ACCOUNTS LOADED ===');
      console.log('Entity ID:', this.entityIdDetails.entityId);
      console.log('Bank Accounts loaded:', this.bankAccounts);
      console.log('Bank Accounts count:', this.bankAccounts ? this.bankAccounts.length : 'null/undefined');
      if (this.bankAccounts && this.bankAccounts.length > 0) {
        console.log('Bank Account Numbers:', this.bankAccounts.map(ba => ba.accountNumber));
      }
      console.log('===========================');
    });

    this.loadTransactionCounterParty();
    const setCountryTypes = (values) => {
      this.countryTypes = values;
    };
    const setCashFlows = (values) => {
      this.cashFlows = values;
    };
    const setTransactionFrequencyPeriod = (values) => {
      this.transactionFrequencyPeriods = values;
    };
    const setRoles = (values) => {
      this.roles = values;
    };

    this.warmUpService.getApplicationValueList(
      ApplicationTypeConstants.COUNTRY_TYPE, setCountryTypes);
    this.warmUpService.getApplicationValueList(
      ApplicationTypeConstants.CASH_FLOW, setCashFlows);
    this.warmUpService.getApplicationValueList(
      ApplicationTypeConstants.RELATION_ROLE_TYPES, setRoles);
    this.warmUpService.getApplicationValueList(
      ApplicationTypeConstants.TRANSACTION_FREQUENCY_PERIOD,
      (data) => setTransactionFrequencyPeriod(this.warmUpService.excludeCustomPeriod(data)));
  }

  loadTransactionRules() {
    this.entityTransactionProfileService.getTransactionRulesByClientId(
      this.entityIdDetails.clientId).subscribe(response => {
      this.transactionRules = response;
    });
  }

  loadTransactionCounterParty() {
    this.entityTransactionProfileService.getTransactionCounterParty(
      // Load all relations so we can resolve auto-prefilled counterparty names reliably
      // (limit=10 often doesn't include the needed counterparty)
      this.entityIdDetails.entityId, null).subscribe(response => {
      if (response.flagResult) {
        this.counterParties = response.arrResult;
        // If counterparty name was prefilled (e.g. from TM Create Rule), resolve id now that relations are loaded
        this.tryResolveCounterPartyIdFromName();
      }
    });
  }

  onValueChanged(data?: any) {
    if (!this.ruleForm) {
      return;
    }
    const form = this.ruleForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      
      if (field === 'ruleCriteria') {
        // Handle form-level validation error
        if (form.errors && form.errors['ruleCriteria'] && (form.touched || form.dirty)) {
          const messages = this.validationMessages[field];
          this.formErrors[field] = messages['required'] || '';
        }
      } else {
        const control = form.get(field);
        if (control && control.touched && !control.valid) {
          const messages = this.validationMessages[field];
          for (const key in control.errors) {
            this.formErrors[field] += messages[key] + ' ';
          }
        }
      }
    }
  }

  onEntitySelection(searchDetails: GenericSearchDetails) {
    this.selectedEntity = searchDetails;
    this.ruleForm.controls['clientName'].setValue(this.selectedEntity.clientName);
    this.ruleForm.controls['clientName'].markAsTouched();
  }

  selectedIndexChange(tabIndex: number) {
    this.selectedIndex = tabIndex;

  }

  getCounterPartyId(counterPartyName: number) {
    const relation = this.counterParties['relations'].find(
      obj => obj.name === counterPartyName);
    return relation && relation.entityId || '';
  }

  getApplicationValueName(valueList, applicationValueId) {
    const applicationValue = valueList.find(
      obj => obj.id === applicationValueId);
    return applicationValue && applicationValue.name || '';
  }

  enableOptionStatus(optionName) {
    if (this.options.hasOwnProperty(optionName) && this.options[optionName]) {
      this.options[optionName] = false;
    } else {
      this.options[optionName] = true;
    }
  }

  createNewCounterParty() {
    const relationVO = new EntityRelation();
    relationVO.subjectId = this.entityIdDetails.entityId;
    relationVO.entityId = this.selectedEntity.entityId;
    relationVO.clientId = this.selectedEntity.clientId;
    relationVO.detailId = this.selectedEntity.id;
    relationVO.role = this.ruleForm.controls['role']['value'];
    relationVO.entityType = EntityType[this.entityIdDetails.entityType.toString()];
    this.entityRelationsService.addRelation(this.entityIdDetails.entityId, relationVO)
      .subscribe(response => {
        this.loadTransactionCounterParty();
        this.callSnackBarService(response, MessageService.COUNTER_SAVE_SUCCESS, '');
      }, err => {
        this.callSnackBarService(err, '', MessageService.COUNTER_SAVE_FAILUR);
      });
  }

  showCreateClientContent() {
    this.showClientPage = true;
  }

  editTransactionRule(rule: TransactionRule) {
    // Add null check to prevent the error
    if (!rule || !rule.id) {
      console.error('Cannot edit transaction rule: rule is null or missing ID', rule);
      this.snackBarService.showSimpleMsj('Error: Transaction rule data is missing. The rule may have been deleted or corrupted.');
      return;
    }
    
    this.selectedTranactionRule = rule;
    this.selectedIndex = 1;
    
    // DEBUG: Log when a transaction rule is selected
    console.log('=== TRANSACTION RULE SELECTED ===');
    console.log('Rule ID:', rule.id);
    console.log('Rule Name:', rule.name);
    console.log('Rule AccountNo:', rule.accountNo);
    console.log('Bank Accounts available at selection time:', this.bankAccounts ? this.bankAccounts.length : 'not loaded');
    console.log('================================');
    
    // Use setTimeout to ensure bank accounts are loaded before updating form
    // This handles the case where bank accounts load asynchronously after the rule is selected
    setTimeout(() => {
      this.updateTransactionFormWithTransactionRule();
    }, 100);
  }

  deleteTransactionRule(transactionRule: TransactionRule) {
    this.isLoading = true;
    this.entityTransactionProfileService.removeTransactionRule(transactionRule.id)
      .subscribe(response => {
        this.loadTransactionRules();
        this.callSnackBarService(response, MessageService.TRANSACTION_DELETE_SUCCESS, '');
      }, err => {
        this.callSnackBarService(err, '', MessageService.TRANSACTION_DELETE_FAILURE);
      });
  }

  saveData(value) {
    // Mark form and relevant controls as touched to show validation errors
    Object.keys(this.ruleForm.controls).forEach(key => {
      this.ruleForm.get(key).markAsTouched();
    });
    this.onValueChanged();
    
    // Check validation before proceeding
    if (!this.ruleForm.valid) {
      this.isLoading = false;
      return;
    }
    
    this.isLoading = true;
    // Check if we need to create an agreement first
    const agreementIdValue = this.ruleForm.get('transactionalRelationshipId').value;
    if (!agreementIdValue || agreementIdValue === 0) {
      // Create a new agreement first
      this.createAgreementAndSave(value);
    } else {
      // Use existing agreement
      this.agreementId = agreementIdValue;
      this.saveByCashFlow(value);
    }
  }

  createAgreementAndSave(value) {
    // Create a new agreement with the profile name as description
    const agreement = new Agreement();
    agreement.description = value.name || 'New Transactional Relationship';
    agreement.effectiveDate = new Date();
    agreement.relationEntityId = this.entityIdDetails.entityId;

    this.entityTransactionProfileService.saveAgreement(agreement).subscribe(response => {
      if (response.flagResult && response.arrResult) {
        this.agreementId = response.arrResult;
        this.ruleForm.patchValue({
          transactionalRelationshipId: this.agreementId
        });
        this.saveByCashFlow(value);
      } else {
        this.isLoading = false;
        this.snackBarService.showStatus(response, '', 'Failed to create Transactional Relationship');
      }
    }, error => {
      this.isLoading = false;
      console.error('Error creating agreement:', error);
      this.snackBarService.showStatus(error, '', 'Failed to create Transactional Relationship');
    });
  }

  private saveByCashFlow(value) {
    const cashFlowName = this.getApplicationValueName(this.cashFlows, this.ruleForm.get('cashFlow').value);
    if (cashFlowName === 'Incoming') {
      this.saveRight(value);
    } else {
      this.saveObligation(value);
    }
  }

  saveObligation(value) {
    this.isLoading = true;
    const obligation = new Obligation();
    obligation.id = this.selectedTxRule && this.selectedTxRule.id || 0;
    obligation.obligation = value.name;
    obligation.counterPartyId = this.normalizeCounterPartyId(value.counterPartyId);
    obligation.counterPartyName = value.counterPartyName || null;
    obligation.agreementId = this.agreementId;
    obligation.date = new Date();
    
    // Create full transaction rule object - backend will detect it has full data and create both atomically
    obligation.transactionRule = this.createTransactionRuleFromForm(value);
    
    this.entityTransactionProfileService.saveObligation(obligation).subscribe(response => {
      this.isLoading = false;
      if (response.flagResult) {
        obligation.id = response.arrResult;
        this.dialogRef.close(obligation);
      }
      this.callSnackBarService(response, MessageService.OBLIGATION_SAVE_SUCCESS, '');
    }, err => {
      this.isLoading = false;
      this.callSnackBarService(err, '', MessageService.OBLIGATION_SAVE_FAILURE);
    });
  }

  saveRight(value) {
    this.isLoading = true;
    const right = new Right();
    right.id = this.selectedTxRule && this.selectedTxRule.id || 0;
    right.right = value.name;
    right.counterPartyId = this.normalizeCounterPartyId(value.counterPartyId);
    right.counterPartyName = value.counterPartyName || null;
    right.agreementId = this.agreementId;
    right.date = new Date();
    
    // Create full transaction rule object - backend will detect it has full data and create both atomically
    right.transactionRule = this.createTransactionRuleFromForm(value);

    this.entityTransactionProfileService.saveRight(right).subscribe(response => {
      this.isLoading = false;
      if (response.flagResult) {
        right.id = response.arrResult;
        this.dialogRef.close(right);
      }
      this.callSnackBarService(response, MessageService.RIGHT_SAVE_SUCCESS, '');
    }, err => {
      this.isLoading = false;
      this.callSnackBarService(err, '', MessageService.RIGHT_SAVE_FAILURE);
    });
  }

  addTransactionRule(value) {
    this.isLoading = true;
    const transactionRule = new TransactionRule();
    transactionRule.id = 0;
    transactionRule.accountNo = value.accountNo;
    transactionRule.name = value.profileName;
    transactionRule.txnDescription = value.txnDescription;
    if (this.options.hasOwnProperty('amountRange')) {
      transactionRule.amountFrom = value.amountFrom;
      transactionRule.amountTo = value.amountTo;
    }

    if (this.options.hasOwnProperty('maxAmount')) {
      transactionRule.maxAmount = value.maxAmount;
      transactionRule.maxAmountPeriod = value.maxAmountPeriod;
      transactionRule.maxAmountPeriodName = this.getApplicationValueName(
        this.transactionFrequencyPeriods, value.maxAmountPeriod);
    }

    if (this.options.hasOwnProperty('frequency')) {
      transactionRule.frequency = value.frequency;
      transactionRule.frequencyPeriod = value.frequencyPeriod;
      transactionRule.frequencyPeriodName = this.getApplicationValueName(
        this.transactionFrequencyPeriods, value.frequencyPeriod);
    }

    if (this.options.hasOwnProperty('originCountry')) {
      transactionRule.originCountry = value.originCountry;
      transactionRule.originCountryName = this.getApplicationValueName(
        this.countryTypes, value.originCountry);
    }

    if (this.options.hasOwnProperty('counterParty')) {
      transactionRule.counterPartyId = this.normalizeCounterPartyId(value.counterPartyId);
      transactionRule.counterPartyName = value.counterPartyName || null;
      transactionRule.counterPartyAccountNumber = value.counterPartyAccountNumber || null;
    }

    transactionRule.cashFlow = value.cashFlow;
    transactionRule.cashFlowName = this.getApplicationValueName(this.cashFlows, value.cashFlow);

    this.entityTransactionProfileService.saveTransactionRuleForRight(
      this.entityIdDetails.clientId, 0, transactionRule).subscribe(response => {
      if (response.flagResult) {
        this.selectedIndex = 0;
        this.lastTrxId = response.arrResult;
        this.loadTransactionRules();
      }
      this.callSnackBarService(response, MessageService.RIGHT_SAVE_SUCCESS, '');
    }, err => {
      this.callSnackBarService(err, '', MessageService.RIGHT_SAVE_FAILURE);
    });
  }

  onSubmit({ value, valid }) {
    // Directly save data - backend will handle creating rule and obligation/right atomically
    this.saveData(value);
  }

  private createTransactionRuleFromForm(formValues: any): TransactionRule {
    const transactionRule = new TransactionRule();
    // For new rules, set id to 0. For existing rules, use the existing id.
    // When editing, use the existing transaction rule ID if available
    if (this.selectedTxRule && this.selectedTxRule.transactionRule && this.selectedTxRule.transactionRule.id) {
      transactionRule.id = this.selectedTxRule.transactionRule.id;
    } else if (this.lastTrxId) {
      transactionRule.id = this.lastTrxId;
    } else {
      transactionRule.id = 0; // New rule
    }
    
    transactionRule.accountNo = formValues.accountNo || null;
    transactionRule.name = formValues.profileName || formValues.name;
    transactionRule.txnDescription = formValues.txnDescription;
    transactionRule.cashFlow = formValues.cashFlow;
    transactionRule.cashFlowName = this.getApplicationValueName(this.cashFlows, formValues.cashFlow);

    if (this.options.hasOwnProperty('amountRange')) {
      transactionRule.amountFrom = formValues.amountFrom;
      transactionRule.amountTo = formValues.amountTo;
    }

    if (this.options.hasOwnProperty('maxAmount')) {
      transactionRule.maxAmount = formValues.maxAmount;
      transactionRule.maxAmountPeriod = formValues.maxAmountPeriod;
      transactionRule.maxAmountPeriodName = this.getApplicationValueName(
        this.transactionFrequencyPeriods, formValues.maxAmountPeriod);
    }

    if (this.options.hasOwnProperty('frequency')) {
      transactionRule.frequency = formValues.frequency;
      transactionRule.frequencyPeriod = formValues.frequencyPeriod;
      transactionRule.frequencyPeriodName = this.getApplicationValueName(
        this.transactionFrequencyPeriods, formValues.frequencyPeriod);
    }

    if (this.options.hasOwnProperty('originCountry')) {
      transactionRule.originCountry = formValues.originCountry;
      transactionRule.originCountryName = this.getApplicationValueName(
        this.countryTypes, formValues.originCountry);
    }

    transactionRule.counterPartyId = this.normalizeCounterPartyId(formValues.counterPartyId);
    transactionRule.counterPartyName = formValues.counterPartyName || null;
    transactionRule.counterPartyAccountNumber = formValues.counterPartyAccountNumber || null;
    // Ensure backend receives agreementId (transaction_rule.agreement_id is NOT NULL)
    // Use the selected agreement (this.agreementId) as primary source, fallback to form value.
    const agrId = (this.agreementId && this.agreementId > 0)
      ? this.agreementId
      : (formValues && formValues.transactionalRelationshipId ? Number(formValues.transactionalRelationshipId) : 0);
    if (agrId && agrId > 0) {
      (transactionRule as any).agreementId = agrId;
    }

    return transactionRule;
  }

  /**
   * Normalizes counterPartyId: converts empty strings, null, undefined, or 0 to null.
   * This ensures the backend receives null instead of empty string, preventing NullPointerException.
   */
  private normalizeCounterPartyId(counterPartyId: any): number | null {
    if (counterPartyId === null || counterPartyId === undefined || counterPartyId === '' || counterPartyId === 0) {
      return null;
    }
    // Convert string to number if it's a valid number string
    if (typeof counterPartyId === 'string' && counterPartyId.trim() !== '') {
      const num = Number(counterPartyId);
      return isNaN(num) || num === 0 ? null : num;
    }
    // Return as number if it's already a valid number
    const num = Number(counterPartyId);
    return isNaN(num) || num === 0 ? null : num;
  }

  createTransactionRule({value, valid}) {
    this.addTransactionRule(value);
  }
  callSnackBarService(response: any, success: string, failur: string) {
    this.isLoading = false;
    this.snackBarService.showStatus(response, success, failur);
  }

  transactionRuleChange(selectedTranaction: TransactionRule) {
    this.selectedTranactionRule = selectedTranaction;
  }

  loadAgreements(): Observable<Agreement[]> {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      return this.entityTransactionProfileService.getAgreements(this.entityIdDetails.entityId)
        .map(agreements => {
          this.agreements = agreements || [];
          this.filteredAgreements = this.agreements;
          // If agreementId is set and > 0, select that agreement
          if (this.agreementId && this.agreementId > 0) {
            const agreement = this.agreements.find(a => a.id === this.agreementId);
            if (agreement) {
              this.selectedAgreement = agreement;
              this.ruleForm.patchValue({
                transactionalRelationship: agreement.description,
                transactionalRelationshipId: agreement.id
              });
            }
          }
          return this.agreements;
        });
    }
    return Observable.of([]);
  }

  filterAgreements() {
    if (!this.agreementSearchKeyword || this.agreementSearchKeyword.trim() === '') {
      this.filteredAgreements = this.agreements;
    } else {
      const keyword = this.agreementSearchKeyword.toLowerCase().trim();
      this.filteredAgreements = this.agreements.filter(agreement => {
        const description = agreement.description ? agreement.description.toLowerCase() : '';
        return description.includes(keyword);
      });
    }
  }

  onAgreementSearchChange() {
    this.filterAgreements();
  }

  onAgreementSearchFocus() {
    this.isAgreementInputFocused = true;
    // Show all agreements when focusing, allowing users to select without typing
    if (this.selectedAgreement) {
      // Clear search when focusing if an agreement is already selected
      this.agreementSearchKeyword = '';
    }
    // Always show filtered agreements when focusing (either all or filtered by keyword)
    if (!this.agreementSearchKeyword || this.agreementSearchKeyword.trim() === '') {
      this.filteredAgreements = this.agreements;
    } else {
      this.filterAgreements();
    }
  }

  onAgreementSearchBlur() {
    // Don't process blur if we're in the middle of selecting an agreement
    if (this.isSelectingAgreement) {
      return;
    }
    this.isAgreementInputFocused = false;
    // Restore selected agreement description if nothing was selected
    if (this.selectedAgreement && !this.agreementSearchKeyword) {
      this.agreementSearchKeyword = this.selectedAgreement.description;
      this.filteredAgreements = [];
    }
  }

  selectAgreement(agreement: Agreement) {
    this.isSelectingAgreement = true;
    this.selectedAgreement = agreement;
    this.agreementId = agreement.id;
    this.agreementSearchKeyword = agreement.description;
    this.filteredAgreements = [];
    this.isAgreementInputFocused = false;
    this.ruleForm.patchValue({
      transactionalRelationship: agreement.description,
      transactionalRelationshipId: agreement.id
    });
    // Reset the flag after a short delay to allow the blur event to complete
    setTimeout(() => {
      this.isSelectingAgreement = false;
    }, 100);
  }

  openCreateAgreementDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.width = '450px';

    const createDialogRef = this.dialog.open(SaveAgreementComponent, config);
    createDialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
    createDialogRef.componentInstance.action = 'Add';
    
    createDialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Reload agreements and select the newly created one
        // The result is the agreement ID
        this.loadAgreements().subscribe(agreements => {
          const newAgreement = agreements.find(a => a.id === result);
          if (newAgreement) {
            this.selectAgreement(newAgreement);
          }
        }, error => {
          console.error('Error loading agreements after creation:', error);
        });
      }
    });
  }

  closeDialog(): void {
    this.ruleForm.reset();
    this.dialogRef.close();
  }

  onEntityRelationSelectionEvent(selectedRelation: EntityRelation, overlaypanel: OverlayPanel) {
    console.log('=== onEntityRelationSelectionEvent CALLED ===');
    console.log('Selected relation:', selectedRelation);
    console.log('Relation name:', selectedRelation ? selectedRelation.name : 'null');
    console.log('Relation entityId:', selectedRelation ? selectedRelation.entityId : 'null');
    
    if (!selectedRelation) {
      console.error('ERROR: selectedRelation is null or undefined!');
      return;
    }
    
    try {
      this.ruleForm.patchValue({
        counterPartyName: selectedRelation.name,
        counterPartyId: selectedRelation.entityId
      });
      // Ensure cross-field validator recalculates immediately
      this.ruleForm.updateValueAndValidity({ emitEvent: true });
      console.log('Form updated successfully');
      console.log('counterPartyName:', this.ruleForm.get('counterPartyName').value);
      console.log('counterPartyId:', this.ruleForm.get('counterPartyId').value);
      
      // Load counterparty bank accounts when counterparty is selected
      if (selectedRelation.entityId) {
        console.log('Loading bank accounts for entity:', selectedRelation.entityId);
        this.loadCounterpartyBankAccounts(selectedRelation.entityId);
      }
      
      if (overlaypanel) {
        overlaypanel.hide();
        console.log('Overlay panel hidden');
      } else {
        console.warn('WARNING: overlaypanel is null, cannot hide');
      }
    } catch (error) {
      console.error('ERROR in onEntityRelationSelectionEvent:', error);
    }
    console.log('=== onEntityRelationSelectionEvent COMPLETE ===');
  }

  /**
   * If we have a counterPartyName but no counterPartyId, try to resolve it from loaded relations.
   * This addresses the TM "Create rule" flow where counterparty name is prefilled from the transaction,
   * but the relation entityId isn't set unless the user manually selects it.
   */
  private tryResolveCounterPartyIdFromName(): void {
    if (!this.ruleForm) {
      return;
    }
    const idCtrl = this.ruleForm.get('counterPartyId');
    const nameCtrl = this.ruleForm.get('counterPartyName');
    const currentId = idCtrl ? idCtrl.value : null;
    const currentName = nameCtrl ? nameCtrl.value : null;

    if (currentId !== null && currentId !== undefined && currentId !== '' && currentId !== 0) {
      return;
    }
    if (!currentName || typeof currentName !== 'string' || currentName.trim() === '') {
      return;
    }
    if (!this.counterParties || !this.counterParties['relations'] || !Array.isArray(this.counterParties['relations'])) {
      return;
    }

    const normalized = currentName.trim().toLowerCase();
    const matchExact = this.counterParties['relations'].find((r: any) => {
      const rName = (r && r.name) ? String(r.name).trim().toLowerCase() : '';
      return rName !== '' && rName === normalized;
    });

    const normalizeForMatch = (s: string): string => {
      if (!s) return '';
      let x = String(s).toLowerCase();
      // remove punctuation
      x = x.replace(/[^a-z0-9\s]/g, ' ');
      // normalize whitespace
      x = x.replace(/\s+/g, ' ').trim();
      // remove common legal suffixes (very lightweight)
      x = x.replace(/\b(bv|b v|b\.v|nv|n v|n\.v|ltd|inc|llc|gmbh|sa|sarl|srl|spa|plc)\b/g, '').replace(/\s+/g, ' ').trim();
      return x;
    };

    let match = matchExact;
    if (!match) {
      const normTx = normalizeForMatch(currentName);
      if (normTx) {
        match = this.counterParties['relations'].find((r: any) => {
          const rName = r && r.name ? String(r.name) : '';
          const normRel = normalizeForMatch(rName);
          return normRel !== '' && normRel === normTx;
        });
      }
    }

    if (match && match.entityId) {
      this.ruleForm.patchValue(
        { counterPartyName: match.name, counterPartyId: match.entityId },
        { emitEvent: true }
      );
      this.loadCounterpartyBankAccounts(match.entityId);
    }
  }
  
  showRelation(event, overlaypanel: OverlayPanel) {
    console.log('=== showRelation CALLED ===');
    console.log('Event:', event);
    console.log('Overlay panel:', overlaypanel);
    console.log('Container:', this.container);
    console.log('Entity ID Details:', this.entityIdDetails);
    
    if (!overlaypanel) {
      console.error('ERROR: overlaypanel is null or undefined!');
      return;
    }
    
    // Prevent default and stop propagation to avoid conflicts
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      console.log('Event prevented and stopped');
    }
    
    // Check if entityIdDetails is set (required for relation dropdown)
    if (!this.entityIdDetails || !this.entityIdDetails.entityId) {
      console.error('ERROR: entityIdDetails is not set! Cannot load relations.');
      console.log('Current entityIdDetails:', this.entityIdDetails);
      return;
    }
    
    // Use container element for better positioning, especially in Edge when zoomed
    if (this.container && this.container.nativeElement) {
      overlaypanel.appendTo = this.container.nativeElement;
      console.log('Overlay panel appendTo set to container');
    } else {
      overlaypanel.appendTo = 'body';
      console.log('Overlay panel appendTo set to body (container not available)');
    }
    
    try {
      // If overlay is already visible, hide it first
      if (overlaypanel.visible) {
        console.log('Overlay is already visible, hiding first');
        overlaypanel.hide();
        // Wait a bit before showing again
        setTimeout(() => {
          this.showOverlayPanel(overlaypanel, event);
        }, 50);
      } else {
        // Use a small delay to ensure the click event has fully processed
        // This prevents the overlay from immediately closing due to event bubbling
        setTimeout(() => {
          this.showOverlayPanel(overlaypanel, event);
        }, 10);
      }
    } catch (error) {
      console.error('ERROR in showRelation:', error);
    }
    console.log('=== showRelation COMPLETE ===');
  }
  
  private showOverlayPanel(overlaypanel: OverlayPanel, event: any) {
    console.log('=== showOverlayPanel CALLED ===');
    try {
      // Get the actual clickable div wrapper (not the disabled input)
      let targetElement = event ? event.target : null;
      if (targetElement) {
        // If we clicked on the input or its container, find the wrapper div
        const wrapperDiv = targetElement.closest('div[style*="cursor: pointer"]') || 
                          targetElement.closest('.mat-input-container') ||
                          targetElement.closest('div');
        if (wrapperDiv) {
          targetElement = wrapperDiv;
          console.log('Using wrapper div as target:', wrapperDiv);
        }
      }
      
      // Use show() with the target element
      overlaypanel.show(event, targetElement);
      console.log('Overlay panel show() called with target:', targetElement);
      this.cdRef.detectChanges();
      console.log('Change detection triggered');
      
      // Immediately check and adjust position (especially important for Edge when zoomed)
      setTimeout(() => {
        this.adjustOverlayPosition(overlaypanel, event, targetElement);
      }, 50);
      
      // Also check again after a longer delay to catch any late positioning issues
      setTimeout(() => {
        this.adjustOverlayPosition(overlaypanel, event, targetElement);
      }, 200);
    } catch (error) {
      console.error('ERROR in showOverlayPanel:', error);
    }
    console.log('=== showOverlayPanel COMPLETE ===');
  }

  private adjustOverlayPosition(overlaypanel: OverlayPanel, event: any, targetElement: any) {
    if (!overlaypanel.visible) {
      return;
    }
    
    try {
      // Check the actual DOM element
      if (overlaypanel.el && overlaypanel.el.nativeElement) {
        const componentElement = overlaypanel.el.nativeElement;
        
        // Find the actual rendered overlay div (child of p-overlaypanel)
        const actualOverlay = componentElement.querySelector('.ui-overlaypanel') || 
                             componentElement.querySelector('.p-overlaypanel');
        if (actualOverlay) {
          const rect = actualOverlay.getBoundingClientRect();
          const styles = window.getComputedStyle(actualOverlay);
          
          // Get the trigger element - prefer the wrapper div with cursor pointer
          let triggerElement = null;
          if (event && event.target) {
            triggerElement = event.target.closest('div[style*="cursor: pointer"]') || 
                           event.target.closest('.mat-input-container') ||
                           event.target.closest('md-input-container') ||
                           (targetElement && targetElement.closest ? targetElement.closest('div') : targetElement);
          }
          
          // If no trigger found, try to get the counterParty input element
          if (!triggerElement) {
            const counterPartyInput = document.getElementById('counterParty');
            if (counterPartyInput) {
              triggerElement = counterPartyInput.closest('div[style*="cursor: pointer"]') || 
                              counterPartyInput.closest('.mat-input-container') ||
                              counterPartyInput.closest('md-input-container') ||
                              counterPartyInput.parentElement;
            }
          }
          
          if (triggerElement) {
            const triggerRect = triggerElement.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const viewportWidth = window.innerWidth;
            
            // Check if overlay is positioned off-screen or incorrectly
            const isOffScreen = rect.top > viewportHeight || 
                               rect.left > viewportWidth || 
                               rect.top < 0 || 
                               rect.left < 0 ||
                               rect.bottom > viewportHeight + 100 || // Allow some margin
                               rect.right > viewportWidth + 100;
            
            // Also check if overlay is too far from trigger (more than 200px vertically)
            const verticalDistance = Math.abs(rect.top - triggerRect.bottom);
            const horizontalDistance = Math.abs(rect.left - triggerRect.left);
            const isMisaligned = verticalDistance > 200 || horizontalDistance > 300;
            
            if (isOffScreen || isMisaligned) {
              console.warn('WARNING: Overlay positioning issue detected. Adjusting...');
              console.warn('Overlay rect:', rect);
              console.warn('Trigger rect:', triggerRect);
              console.warn('Viewport:', { width: viewportWidth, height: viewportHeight });
              
              // Calculate optimal position
              // Try to position below the trigger element first
              let top = triggerRect.bottom + 5;
              let left = triggerRect.left;
              
              // If it would go off-screen at the bottom, position above instead
              const overlayHeight = rect.height || 300; // Estimate if not available
              if (top + overlayHeight > viewportHeight && triggerRect.top > overlayHeight) {
                top = triggerRect.top - overlayHeight - 5;
              }
              
              // If it would go off-screen on the right, align to the right edge of trigger
              const overlayWidth = rect.width || 300; // Estimate if not available
              if (left + overlayWidth > viewportWidth) {
                left = Math.max(0, triggerRect.right - overlayWidth);
              }
              
              // Ensure it doesn't go off-screen on the left
              if (left < 0) {
                left = 5;
              }
              
              // Apply the position using fixed positioning for better cross-browser support
              actualOverlay.style.position = 'fixed';
              actualOverlay.style.top = top + 'px';
              actualOverlay.style.left = left + 'px';
              actualOverlay.style.zIndex = '10000';
              
              // Force a reflow to ensure the styles are applied
              void actualOverlay.offsetHeight;
              
              console.log('Adjusted overlay position to:', { top, left });
            }
          } else {
            console.warn('WARNING: Could not find trigger element for positioning adjustment');
          }
        } else {
          console.error('ERROR: Actual overlay div not found inside component!');
        }
      } else {
        console.error('ERROR: Overlay panel DOM element not found!');
      }
    } catch (error) {
      console.error('ERROR in adjustOverlayPosition:', error);
    }
  }

  private updateTxnDescription(formData) {
    if (!formData.name) {
      this.ruleForm.get('txnDescription').setValue('', {emitEvent: false});
      return;
    }

    const builder = new TransactionDescriptionBuilder(formData.name);

    if (formData.cashFlow) {
      const cashFlowName = this.getApplicationValueName(this.cashFlows, formData.cashFlow);
      builder.addCashFlow(cashFlowName === 'Incoming' ? 'incoming' : 'outgoing', formData.counterPartyName,
        formData.originCountry ? this.getApplicationValueName(this.countryTypes, formData.originCountry) : '');
    }

    if (this.options['amountRange']) {
      builder.addAmountRange(formData.amountFrom, formData.amountTo);
    }

    if (this.options['maxAmount'] && formData.maxAmount) {
      const period = formData.maxAmountPeriod ?
        this.getApplicationValueName(this.transactionFrequencyPeriods, formData.maxAmountPeriod) : '';
      builder.addMaxAmount(formData.maxAmount, period);
    }

    if (this.options['frequency'] && formData.frequency) {
      const period = formData.frequencyPeriod ?
        this.getApplicationValueName(this.transactionFrequencyPeriods, formData.frequencyPeriod) : '';
      builder.addFrequency(formData.frequency, period);
    }
    this.ruleForm.get('txnDescription').setValue(builder.build(), {emitEvent: false});
  }

}


// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/transaction-rule/add-transaction-rule/add-transaction-rule.component.ts